export default __webpack_public_path__ + "static/media/16_bedroom.fe7e66b4.png";